import { SUPPORTED_UNITS } from '@schuettflix/interfaces';

export type MinValueRule = {
    minValue?: number;
    unit?: SUPPORTED_UNITS;
};

type IsQuantityBelowMinValueParams = {
    quantity?: number;
    unit?: SUPPORTED_UNITS;
    rule?: MinValueRule;
};

export function isQuantityBelowMinValue({ quantity, unit, rule }: IsQuantityBelowMinValueParams): boolean {
    if (quantity === undefined || !unit || !rule?.minValue || !rule.unit || rule.unit !== unit) {
        return false;
    }

    return quantity < rule.minValue;
}
